<template>
    <g>
        <path d="M13.6663 0H0.333008L5.66634 6.30667V10.6667L8.33301 12V6.30667L13.6663 0Z" :fill="iconFill" />
    </g>
</template>
<script>
export default {
    name: "FilterIcon",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
